import { motion } from "framer-motion";
import { socials } from "constants/social";

const Social = () => {
  return (
    <section className="flex gap-8 items-center justify-center p-8">
      {socials.map((social, index) => (
        <motion.a
          key={social.name}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={social.name}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: index * 0.1 }}
          viewport={{ once: true }}
          whileHover={{ scale: 1.2, rotate: 5 }}
          whileTap={{ scale: 0.9 }}
          className="cursor-pointer"
        >
          {social.icon}
        </motion.a>
      ))}
    </section>
  );
};

export default Social;
